<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogs.themeDialog"
      max-width="600"
      scrollable
    >
      <v-card style="padding: 10px">
        <v-card-title
          class="headline lighten-2"
          primary-title
        >
          テーマカラー選択
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col
              v-for="(item,index) in items"
              :key="index"
              lg="5"
            >
              <v-card
                :color="index==user.themeColor ? 'amber':'transparent'"
                elevation="0"
                height="58px"
                width="58px"
                @click="selectItem(index)"
              >
                <div class="d-flex   align-center justify-center fill-height">
                  <ThemeItem :theme="index" />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="saveItem()"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ThemeItem from "@/component/ThemeItem";
import config from "@/const";
import {mapState} from "vuex";

export default {
  props: ["dialogs"],
  data() {
    return {
      items: config.THEME_COLORS
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
    })
  },
  components: {
    ThemeItem
  },
  methods: {
    selectItem(index) {
      this.user.themeColor = index
    },
    saveItem() {
      this.$store.dispatch("userModule/saveSetting").then(value => {
        this.accentColor = this.$vuetify.theme.themes.light.secondary
        const primary = this.$vuetify.theme.themes.light.primary
        const red = parseInt(primary.substring(1, 3), 16);
        const green = parseInt(primary.substring(3, 5), 16);
        const blue = parseInt(primary.substring(5, 7), 16);

        this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
        this.dialogs.themeDialog = false
      }).catch(reason => {
        alert("保存中にエラーが発生しました。もう一度保存してください")
      });
    }
  }

}
</script>

<style>

</style>